import React from 'react'
import PropTypes from 'prop-types'

import Drawer from '@mui/material/Drawer'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  drawer: {
    display: 'flex',
    flexDirection: 'row',
    width: 'auto',
    minWidth: '375px',
  },
}))

const ExpenseAndRevenueDrawer = (props) => {
  const classes = useStyles(props)
  const {
    open,
    onClose,
    children,
  } = props

  return (
    <Drawer
      classes={{ paper: classes.drawer }}
      anchor="right"
      transitionDuration={400}
      open={open}
      onClose={() => { onClose && onClose() }}
      ModalProps={{
        disableBackdropClick: false,
        disableEscapeKeyDown: true,
      }}>
      {children}
    </Drawer>
  )
}

ExpenseAndRevenueDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
}

export default ExpenseAndRevenueDrawer
